import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air-accessories',
  templateUrl: './air-accessories.component.html',
  styleUrls: ['./air-accessories.component.scss']
})
export class AirAccessoriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
